export default __webpack_public_path__ + "media/color/xzc-54a5bace.svg";